import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';

import Plano from '../../interfaces/Plano';
import PlanoCard from './PlanoCard';

interface PlanoListProps {
  planos: Plano[];
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    [theme.breakpoints.down('md')]: {
      overflow: 'auto',
      justifyContent: 'space-between',
    },
  },
}));

export default function PlanoList(props: PlanoListProps) {
  const classes = useStyles();

  const planos: Plano[] = props.planos;

  const cards = planos.map((plano: Plano) => (
    <PlanoCard key={plano.id} plano={plano} />
  ));

  return <Box className={classes.root}>{cards}</Box>;
}
